import { render, staticRenderFns } from "./ProductionUnitList.vue?vue&type=template&id=78f4cc88&scoped=true"
import script from "./ProductionUnitList.vue?vue&type=script&lang=js"
export * from "./ProductionUnitList.vue?vue&type=script&lang=js"
import style0 from "./ProductionUnitList.vue?vue&type=style&index=0&id=78f4cc88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4cc88",
  null
  
)

export default component.exports